
import { Component, Vue, Prop } from "vue-property-decorator"
import { Getter } from "vuex-class"

import { InsightCalculationTotal, Insight, InsightCalculation } from "@/types/insights"

import { formatInsight } from "@/mixins/FormatInsight"
import { TenantFeatures } from "@/types/tenantFeatures"
import { CalculationResults } from "@/types/insights/calculatedResults"

@Component({
	components: {
	}
})
export default class TableCalculations extends Vue {
	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	@Getter("getUseV2")
	private readonly shouldUseNewInterface!: boolean;

	@Prop({ required: true })
	insight!: Insight

	@Prop()
	calculations!: InsightCalculation[]

	@Prop()
	calculationTotals!: InsightCalculationTotal[]

	@Prop()
	group!: CalculationResults

	private isCalculationAvailableInResults (key: string) : boolean {
		return this.group.calculations[key] !== null && this.group.calculations[key] !== undefined
	}

	private groupByText (calculation: any, groupCalculationResult: any): string {
		if (calculation.groupByKeyLabels) {
			const calculationKeys = Object.keys(calculation.groupByKeyLabels).filter(k => groupCalculationResult && groupCalculationResult[k] !== undefined)
			return calculationKeys.map(k => `${calculation.groupByKeyLabels[k]}: ${groupCalculationResult[k] !== null && groupCalculationResult[k] !== undefined
				? formatInsight.methods.roundNumber(groupCalculationResult[k], 2)
				: 0}`)
				.join(", ")
		}
		return ""
	}

	private groupTotalsByText (calculationTotal: InsightCalculationTotal, result: any): string {
		let calcList = calculationTotal.calculationList
		if (calcList && calcList.length > 0) {
			const calculation = this.calculations.find((calc: any) => calc.key === calcList![0])
			return calculation ? this.groupByText(calculation, result) : ""
		}
		return ""
	}

	private roundCalculationValue (number: string) {
		return formatInsight.methods.roundNumber(number, 2)
	}
}

